angular.module('bribac.services.newTestOverviewPopup', [
  'ui.bootstrap',
  'bribac.components.testOverviewPopup'
])

  .factory('newTestOverviewPopup', function(
    $uibModal
  ) {
    return function(test, subject) {
      return $uibModal.open({
        component: 'testOverviewPopup',
        resolve: {
          test: test,
          subject: subject
        },
        backdrop: true,
        windowClass: 'wide-modal'
      })
    }
  })
